import { Button, SvgIcon } from '@mui/material';
import axios from 'axios';
import DownloadIcon from 'mdi-react/DownloadIcon';
import { any, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import { parseFilenameFromContentDisposition } from 'utils/ommniosignSignedZipDownload';

const isSignedCdnUrl = url =>
  Boolean(url && (url.includes('Signature=') || url.includes('Policy=')));

const DownloadButton = ({ src, name = 'file.pdf', className = null, mimeType, sx = null }) => {
  const handleClick = () => {
    // Signed CDN URLs must not send cookies (CORS / wrong host). Legacy cookie hosts need them.
    const useCredentials = !isSignedCdnUrl(src);
    axios({
      url: src,
      method: 'GET',
      responseType: 'blob',
      withCredentials: useCredentials,
    }).then(response => {
      const cd = response.headers?.['content-disposition'];
      const fromHeader = parseFilenameFromContentDisposition(cd);
      const filename = fromHeader || name || 'file.pdf';
      const url = window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
  };
  return (
    <Button variant="outlined" className={className} onClick={handleClick} sx={sx}>
      <SvgIcon sx={{ fontSize: 18, mr: '10px', color: 'primary.main' }}>
        <DownloadIcon />
      </SvgIcon>
      {I18n.t('Documents.Download')}
    </Button>
  );
};

DownloadButton.propTypes = {
  src: string.isRequired,
  name: string,
  mimeType: string.isRequired,
  color: string,
  variant: string,
  className: any,
  sx: any,
};

export default DownloadButton;
